import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";
import {PearlHarborModel} from "../../server/PearlHarborModel";

export class PearlHarborKamakaziWinRunner implements FlowStatePresentation {
    private _tl: TimelineLite

    public shouldRun(): boolean {
        const isFs: boolean = PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode);
        if (!isFs) {
            return false;
        }
        const model: PearlHarborModel = PearlHarbor.model;

        if (model.gameData.brokeBank && model.dogfight.integerRepresentingWhenBreakBank < 15) {
            return false;
        }
        return model.dogfight.kamakazi;
    }

    private completePresentation(flowStateController: FlowStateController) {
        flowStateController.finish();
    }

    public start(flowStateController: FlowStateController): void {
        this._tl = new TimelineLite();
        this._tl.add(PearlHarbor.kamakazi.show());
        const fs:number = 0.033;
        //animation is 326 frames long
        //console.log("PearlHarborKamakaziWinRunner: " + this._tl.duration());
        this._tl.add(() => this.completePresentation(flowStateController));
    }


}